import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import MultiColumnLayout from '../MultiColumnLayout';

export const Wrapper = styled.div`
  background-color: ${themeGet('colors.neutral_2')};
`;

export const StyledContainer = styled(Container)`
  & > h1,
  & > h2,
  & > h3,
  & > h4,
  & > h5,
  & > h6 {
    text-align: center;
    margin-bottom: 35px;
  }

  padding: 50px 0 60px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 50px 90px 60px;

    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 70px 0 90px;
    display: block;
  }
`;

export const Cards = styled(MultiColumnLayout).attrs(({ columns }) => ({
  columns,
}))`
  @media only screen and (max-width: calc(${themeGet(
    'breakpoints.lg'
  )} - 1px)) {
    > div,
    article {
      margin-top: 20px;

      &:first-child {
        margin-top: 10px;
      }
    }
  }
  justify-content: center;
`;
